<template>
    <v-row align="center" class="row--small">
        <v-col cols="12" md="auto">
            <v-select
                v-model="query['searchKey']"
                v-bind="{
                    ...attrs_input,
                    items: searchKeys,
                    loading,
                    clearable: true,
                    placeholder: '전체',
                }"
            />
        </v-col>
        <v-col>
            <v-row class="row--small">
                <v-col>
                    <v-text-field
                        v-model="query['searchValue']"
                        v-bind="{
                            ...attrs_input,
                            loading,
                            clearable: true,
                            placeholder: '검색내용을 입력하세요.',
                        }"
                        class="v-text-field--search"
                        @keydown.enter="emit"
                    >
                        <template #prepend-inner>
                            <div class="pa-8"><i class="icon icon-search-black" /></div>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="auto">
                    <v-btn v-bind="{ loading }" color="grey-6" dark class="min-w-80px min-w-lg-100px" @click="emit">
                        <span>검색</span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { attrs_input } from "@/assets/variables";

const searchKeys = [
    {
        value: "resume.personalInformation.name",
        text: "성명",
    },
    {
        value: "_applicant",
        text: "아이디",
    },
    {
        value: "resume.personalInformation.phone",
        text: "전화번호",
    },
    {
        value: "resume.personalInformation.email",
        text: "이메일",
    },
];

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["searchKey"]: query?.["searchKey"] || null,
    ["searchValue"]: query?.["searchValue"] || null,
});

export default {
    props: {
        value: { type: Object, default: initQuery },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        attrs_input,
        searchKeys,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.value);
        },
        emit() {
            let { ...query } = this.query;

            if (!query["searchKey"]) delete query["searchKey"];
            if (!query["searchValue"]) delete query["searchValue"];

            this.$emit("input", this.query);
        },
    },
};
</script>

<style></style>
